module.exports = __webpack_public_path__ + "static/media/padel.64f0a59b.jpg";